<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="pv"></a> <b>This book is dedicated to an American Icon, the proud</b> <b>Company that builds them, the thousands of people</b> <b>who compose that Company, the founding four men</b> <b>who started it all, their families who carried the</b> <b>dream through good times and bad, and to you the</b> <b>American people who have made Harley-Davidson</b> <b>a symbol of America and freedom.</b></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?d64b4602